import { useCallback, useEffect, useRef } from 'react';
import { useBinaryState } from './use-binary-state';

export const useFocusOnComponent = () => {
  const [isFocused, setIsFocused, setIsNotFocused] = useBinaryState();
  const ref = useRef(null);

  const onFocus = useCallback(() => {
    setIsFocused();
  }, [setIsFocused]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsNotFocused();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [ref, setIsNotFocused]);

  return { ref, isFocused, onFocus };
};
